export default "__VITE_ASSET__BWsdpHuT__";